import Vue from "vue";
import VueRouter from "vue-router";

const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) { 
  return originalPush.call(this, location).catch(err => err)
}


Vue.use(VueRouter);


const midpage = () => import("views/midpage/midpage.vue");
const Home = () => import("views/home/home.vue");

const knowledgecats = () => import("views/knowledgecats/knowledgecats.vue");
const Question = () => import("views/question/question.vue");
const lawyerOnline = () => import("views/lawyerOnline/lawyerOnline.vue");
const onlitdet = () => import("views/onlitdet/onlitdet.vue")
const onlitform = () => import("views/onlitform/onlitform.vue")
const zxcase = () => import("views/case/case.vue");
const otocoudet = () => import("views/otocoudet/otocoudet.vue");
const otocouform = () => import("views/otocouform/otocouform.vue");
const telzx = () => import("views/telzx/telzx.vue");
const telawint = () => import("views/telawint/telawint.vue");
const telzxdet = () => import("views/telzxdet/telzxdet.vue");
const telzxform = () => import("views/telzxform/telzxform.vue");

const hotconsult = () => import("views/hotconsult/hotconsult.vue");
const consultdet = () => import("views/consultdet/consultdet.vue");
const entrust = () => import("views/entrust/entrust.vue");
const entrustdet = () => import("views/entrustdet/entrustdet.vue");
const entrustform = () => import("views/entrustform/entrustform.vue");

const FindLawyers = () => import("views/findLawyers/findLawyers.vue");
const ls = () => import("views/ls/ls.vue");
const lslist = () => import("views/lslist/lslist.vue");
const city = () => import("views/city/city.vue");
const field = () => import("views/field/field.vue");
const hangye = () => import("views/hangye/hangye.vue");
const lawyeroffice = () => import("views/lawyeroffice/lawyeroffice.vue");
const seafirms = () => import("views/seafirms/seafirms.vue");
const sealaw = () => import("views/sealaw/sealaw.vue");


const Laws = () => import("views/laws/laws.vue");
const special = () => import("views/special/special.vue");
const speciallist = () => import("views/speciallist/speciallist.vue");
const specialdet = () => import("views/specialdet/specialdet.vue");

const lawsarticl = () => import("views/lawsarticl/lawsarticl.vue");
const videoclaim = () => import("views/videoclaim/videoclaim.vue");
const audioclaim = () => import("views/audioclaim/audioclaim.vue");
const articleclaim = () => import("views/articleclaim/articleclaim.vue");
const videoimdet = () => import("views/videoimdet/videoimdet.vue");
const audioimdet = () => import("views/audioimdet/audioimdet.vue");
const articimdet = () => import("views/articimdet/articimdet.vue");

const tiaoli = () => import("views/tiaoli/tiaoli.vue");
const tiaoliify = () => import("views/tiaoliify/tiaoliify.vue");
const tiaoliifyul = () => import("views/tiaoliifyul/tiaoliifyul.vue");
const tiaolidetail = () => import("views/tiaolidetail/tiaolidetail.vue");


const zuiming = () => import("views/zuiming/zuiming.vue");
const zuiminlist = () => import("views/zuiminlist/zuiminlist.vue");
const zuimindetail = () => import("views/zuimindetail/zuimindetail.vue");
const zmdet_i = () => import("views/zuimindetail/child/zmdet_i.vue");
const zmdet_t = () => import("views/zuimindetail/child/zmdet_t.vue");

const fangan = () => import("views/fangan/fangan.vue");
const fgartic = () => import("views/fgartic/fgartic.vue");

const contractmodel = () => import("views/contractmodel/contractmodel.vue");
const hdcht = () => import("views/hdcht/hdcht.vue");
const conmodet = () => import("views/conmodet/conmodet.vue");
const conmodwrite = () => import("views/conmodwrite/conmodwrite.vue");
const conmodporder = () => import("views/conmodporder/conmodporder.vue");
const settlement = () => import("views/settlement/settlement.vue");

const DeskCalc = () => import("views/DeskCalc/DeskCalc.vue");
const Susong = () => import("views/DeskCalc/child/calc_susong.vue");


const logreg = () => import("views/logreg/logreg.vue"); 
const login = () => import("views/login/login.vue");
const logsig = () => import("views/logsig/logsig.vue");
const logsig_1 = () => import("views/logsig/child/logsig_1.vue");
const logsig_2_1 = () => import("views/logsig/child/logsig_2_1.vue");
const logsig_2_2 = () => import("views/logsig/child/logsig_2_2.vue");
const logsig_3 = () => import("views/logsig/child/logsig_3.vue");
const fgtpwd = () => import("views/fgtpwd/fgtpwd.vue");
const fgtpwd_1 = () => import("views/fgtpwd/child/fgtpwd_1.vue");
const fgtpwd_2 = () => import("views/fgtpwd/child/fgtpwd_2.vue");
const fgtpwd_3 = () => import("views/fgtpwd/child/fgtpwd_3.vue");
const usermid = () => import("views/usermid/usermid.vue");
const my_advice = () => import("views/my_advice/my_advice.vue");
const my_praise = () => import("views/my_praise/my_praise.vue");
const my_focus = () => import("views/my_focus/my_focus.vue");
const my_shop_record = () => import("views/my_shop_record/my_shop_record.vue");
const my_help = () => import("views/my_help/my_help.vue");
const my_usercen = () => import("views/my_usercen/my_usercen.vue");




const routes = [{
    path: "/",
    component: midpage,
    children: [{
        path: "",
        name: "home",
        component: Home,
        meta: {
          title: '律观网'
        }
      },
	  {
	    path: "/knowledgecats",
	    name: "knowledgecats",
	    component: knowledgecats,
	    meta: {
	      title: '法律领域'
	    },
	  },
      {
        path: "/question",
        name: "question",
        component: Question,
        meta: {
          title: '法律咨询'
        },
      },
      {
        path: '/question/lawyeronline',
        name: "question_lawyeronline",
        component: lawyerOnline,
        meta: {
          title: '在线咨询'
        },
      },
	  
      {
        path: "/question/onlitdet",
        name: "onlitdet",
        component: onlitdet,
        meta: {
          title: '在线咨询内容'
        }
      },

      {
        path: "/question/onlitform",
        name: "onlitform",
        component: onlitform,
        meta: {
          title: '在线咨询表单'
        }
      },

      {
        path: '/question/case',
        name: "zxcase",
        component: zxcase,
        meta: {
          title: '一对一咨询'
        },
      },
      {
        path: '/question/otocoudet',
        name: "otocoudet",
        component: otocoudet,
        meta: {
          title: '一对一咨询内容页'
        },
      },

      {
        path: '/question/otocouform',
        name: "otocouform",
        component: otocouform,
        meta: {
          title: '一对一咨询表单'
        },
      },
      {
        path: '/question/telzx',
        name: "telzx",
        component: telzx,
        meta: {
          title: '电话咨询'
        },
      },
      {
        path: '/question/telawint',
        name: "telawint",
        component: telawint,
        meta: {
          title: '律师介绍（电话咨询）'
        },
      },
      {
        path: '/question/telzxdet',
        name: "telzxdet",
        component: telzxdet,
        meta: {
          title: '电话咨询详情页面'
        },
      },
      {
        path: '/question/telzxform',
        name: "telzxform",
        component: telzxform,
        meta: {
          title: '电话咨询表单页面'
        },
      },

      {
        path: '/question/hotconsult',
        name: "hotconsult",
        component: hotconsult,
        meta: {
          title: '热门咨询'
        },
      },
      {
        path: '/question/consultdet',
        name: "consultdet",
        component: consultdet,
        meta: {
          title: '咨询内容页'
        },
      },
      {
        path: '/question/entrust',
        name: "entrust",
        component: entrust,
        meta: {
          title: '案件委托'
        },
      },
      {
        path: '/question/entrustdet',
        name: "entrustdet",
        component: entrustdet,
        meta: {
          title: '案件委托内容'
        },
      },
      {
        path: '/question/entrustform',
        name: "entrustform",
        component: entrustform,
        meta: {
          title: '案件委托表单页'
        },
      },
      {
        path: "/findLawyers",
        name: "findLawyers",
        component: FindLawyers,
        meta: {
          title: '找律师'
        }
      },
      {
        path: "/findLawyers/city",
        name: "city",
        component: city,
        meta: {
          title: '按地区找律师'
        }
      },
      {
        path: "/findLawyers/field",
        name: "field",
        component: field,
        meta: {
          title: '按专业找律师'
        }
      },
      {
        path: "/findLawyers/ls",
        name: "ls",
        component: ls,
        meta: {
          title: '按问题找律师'
        }
      },
      {
        path: "/findLawyers/lslist",
        name: "lslist",
        component: lslist,
        meta: {
          title: '按问题找律师列表页'
        }
      },
      {
        path: "/findLawyers/hangye",
        name: "hangye",
        component: hangye,
        meta: {
          title: '按行业找律师'
        }
      },
      {
        path: "/findLawyers/lawyeroffice",
        name: "lawyeroffice",
        component: lawyeroffice,
        meta: {
          title: '按律所找律师'
        }
      },
      {
        path: "/findLawyers/seafirms",
        name: "seafirms",
        component: seafirms,
        meta: {
          title: '搜索律所'
        }
      },
      {
        path: "/findLawyers/sealaw",
        name: "sealaw",
        component: sealaw,
        meta: {
          title: '搜索律师'
        }
      },

      {
        path: "/laws",
        name: "laws",
        component: Laws,
        meta: {
          title: '法律知识'
        }
      },
      {
        path: "/laws/lawsarticl",
        name: "lawsarticl",
        component: lawsarticl,
        meta: {
          title: '法律知识'
        }
      },
      {
        path: "/laws/special",
        name: "special",
        component: special,
        meta: {
          title: '法律聚焦'
        }
      },
      {
        path: "/laws/speciallist",
        name: "speciallist",
        component: speciallist,
        meta: {
          title: '法律聚焦列表'
        }
      },
      {
        path: "/laws/specialdet",
        name: "specialdet",
        component: specialdet,
        meta: {
          title: '法律聚焦内容'
        }
      },
      {
        path: "/laws/videoclaim",
        name: "videoclaim",
        component: videoclaim,
        meta: {
          title: '视频说法'
        }
      },
      {
        path: "/laws/videoimdet",
        name: "videoimdet",
        component: videoimdet,
        meta: {
          title: '视频说法内容页'
        }
      },
      {
        path: "/laws/audioclaim",
        name: "audioclaim",
        component: audioclaim,
        meta: {
          title: '音频说法'
        }
      },
      {
        path: "/laws/audioimdet",
        name: "audioimdet",
        component: audioimdet,
        meta: {
          title: '音频说法内容页'
        }
      },
      {
        path: "/laws/articleclaim",
        name: "articleclaim",
        component: articleclaim,
        meta: {
          title: '律师解答'
        }
      },
      {
        path: "/laws/articimdet",
        name: "articimdet",
        component: articimdet,
        meta: {
          title: '律师解答内容页'
        }
      },

      {
        path: "/jpcol/tiaoli",
        name: "tiaoli",
        component: tiaoli,
        meta: {
          title: '法律条例'
        }
      },
      {
        path: "/jpcol/tiaoli/tiaoliify",
        name: "tiaoliify",
        component: tiaoliify,
        meta: {
          title: '条例类目'
        }
      },
      {
        path: "/jpcol/tiaoli/tiaoliifyul",
        name: "tiaoliifyul",
        component: tiaoliifyul,
        meta: {
          title: '条例类目列表'
        }
      },
      {
        path: "/jpcol/tiaoli/tiaolidetail",
        name: "tiaolidetail",
        component: tiaolidetail,
        meta: {
          title: '条例类目-详情'
        }
      },

      {
        path: "/jpcol/zuiming",
        name: "zuiming",
        component: zuiming,
        meta: {
          title: '罪名库'
        }
      },
      {
        path: "/jpcol/zuiminlist",
        name: "zuiminlist",
        component: zuiminlist,
        meta: {
          title: '罪名库列表'
        }
      },
      {
        path: "/jpcol/zuimindetail",
        component: zuimindetail,
        meta: {
          title: '罪名库详情页'
        },
      },

      {
        path: "/jpcol/fangan",
        name: "fangan",
        component: fangan,
        meta: {
          title: '解决方案'
        }
      },
      {
        path: "/jpcol/fgartic",
        name: "fgartic",
        component: fgartic,
        meta: {
          title: '方案详情'
        }
      },

      {
        path: "/jpcol/contractmodel",
        name: "contractmodel",
        component: contractmodel,
        meta: {
          title: '合同范本'
        }
      },
      {
        path: "/jpcol/contractmodel/hdcht",
        name: "hdcht",
        component: hdcht,
        meta: {
          title: '合同范本列表'
        }
      },
      {
        path: "/jpcol/hdcht/conmodet",
        name: "conmodet",
        component: conmodet,
        meta: {
          title: '合同详情'
        }
      },
      {
        path: "/jpcol/conmodwrite",
        name: "conmodwrite",
        component: conmodwrite,
        meta: {
          title: '合同代写'
        }
      },
      {
        path: "/jpcol/conmodporder",
        name: "conmodporder",
        component: conmodporder,
        meta: {
          title: '下单'
        }
      },
      {
        path: "/jpcol/settlement",
        name: "settlement",
        component: settlement,
        meta: {
          title: '结算'
        }
      },


      {
        path: "/jpcol/DeskCalc",
        name: "DeskCalc",
        component: DeskCalc,
        redirect: '/jpcol/DeskCalc/Susong',
        children: [{
          path: "Susong",
          component: Susong,
          meta: {
            title: '诉讼费计算器'
          }
        }],
        meta: {
          title: '实用计算器'
        }
      },

    ]
  },
  {
    path: "/log",
    component: logreg,
    redirect: '/log/login',
    children: [{
        path: "login",
        name: "login",
        component: login,
        meta: {
          title: '用户登录'
        }
      },
      {
        path: "logsig",
        name: "logsig",
        component: logsig,
        redirect: '/log/logsig/logsig_1',
        children: [{
            path: "logsig_1",
            name: "logsig_1",
            component: logsig_1,
            meta: {
              title: '用户注册'
            }
          },
          {
            path: "logsig_2_1",
            name: "logsig_2_1",
            component: logsig_2_1,
            meta: {
              title: '用户注册'
            }
          },
          {
            path: "logsig_2_2",
            name: "logsig_2_2",
            component: logsig_2_2,
            meta: {
              title: '用户注册'
            }
          },

          {
            path: "logsig_3",
            name: "logsig_3",
            component: logsig_3,
            meta: {
              title: '用户注册'
            }
          }
        ]
      },
      {
        path: "fgtpwd",
        name: "fgtpwd",
        component: fgtpwd,
        redirect: '/log/fgtpwd/fgtpwd_1',
        children: [{
            path: "fgtpwd_1",
            name: "fgtpwd_1",
            component: fgtpwd_1,
            meta: {
              title: '忘记密码'
            }
          },
          {
            path: "fgtpwd_2",
            name: "fgtpwd_2",
            component: fgtpwd_2,
            meta: {
              title: '忘记密码'
            }
          },
          {
            path: "fgtpwd_3",
            name: "fgtpwd_3",
            component: fgtpwd_3,
            meta: {
              title: '忘记密码'
            }
          },
        ]
      },
    ]
  },

  {
    path: "/user",
    component: usermid,
    children: [{
        path: "my_advice",
        name: "my_advice",
        component: my_advice,
        meta: {
          title: '我的咨询'
        }
      }, {
        path: "my_focus",
        name: "my_focus",
        component: my_focus,
        meta: {
          title: '我的关注'
        }
      },
      {
        path: "my_praise",
        name: "my_praise",
        component: my_praise,
        meta: {
          title: '我的点赞'
        }
      },
      {
        path: "my_shop_record",
        name: "my_shop_record",
        component: my_shop_record,
        meta: {
          title: '购买记录'
        }
      },
      {
        path: "my_help",
        name: "my_help",
        component: my_help,
        meta: {
          title: '帮助中心'
        }
      },
      {
        path: "my_usercen",
        name: "my_usercen",
        component: my_usercen,
        meta: {
          title: '个人中心'
        }
      },
    ]
  },

];




const router = new VueRouter({
  routes,
  scrollBehavior(to, from, saveTop) { 
    if (saveTop) {
      return saveTop;
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  },
});

export default router;